import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faLockAlt,
  faSearch,
  faList,
  faLongArrowAltLeft,
  faChevronDown,
  faChevronUp,
  faImages,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faUndo,
  faUpload,
  faCaretDown,
  faSignInAlt,
  faExternalLink,
  faCaretUp,
  faTrashAlt,
  faEdit,
  faLink,
  faHome,
  faChartLine,
  faWonSign,
  faUserChart,
  faGreaterThan,
  faCoins,
  faPowerOff,
  faUserLock,
  faPlus,
  faTable,
  faHistory,
  faUserAlt,
  faSyncAlt,
  faScroll,
  faCommentAltDots,
  faSpellCheck,
  faMobile,
  faFileSearch,
  faCopy,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faInfoCircle,
  faCheckSquare,
  faAngleRight,
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import { faCube } from '@fortawesome/pro-duotone-svg-icons';

const Icon = (props) => {
  const { icon, color = '#e8e9ec', ...rest } = props;
  return (
    <>
      <FontAwesomeIcon
        icon={
          icon === 'faLockAlt'
            ? faLockAlt
            : icon === 'faUser'
            ? faUser
            : icon === 'faTimes'
            ? faTimes
            : icon === 'faSearch'
            ? faSearch
            : icon === 'faList'
            ? faList
            : icon === 'faUndo'
            ? faUndo
            : icon === 'faUpload'
            ? faUpload
            : icon === 'faCheckSquare'
            ? faCheckSquare
            : icon === 'faCaretDown'
            ? faCaretDown
            : icon === 'faInfoCircle'
            ? faInfoCircle
            : icon === 'faExternalLink'
            ? faExternalLink
            : icon === 'faSignInAlt'
            ? faSignInAlt
            : icon === 'faLongArrowAltLeft'
            ? faLongArrowAltLeft
            : icon === 'faCube'
            ? faCube
            : icon === 'faChevronDown'
            ? faChevronDown
            : icon === 'faChevronUp'
            ? faChevronUp
            : icon === 'faCaretUp'
            ? faCaretUp
            : icon === 'faTrashAlt'
            ? faTrashAlt
            : icon === 'faImages'
            ? faImages
            : icon === 'faEdit'
            ? faEdit
            : icon === 'faLink'
            ? faLink
            : icon === 'faHome'
            ? faHome
            : icon === 'faChartLine'
            ? faChartLine
            : icon === 'faUserChart'
            ? faUserChart
            : icon === 'faWonSign'
            ? faWonSign
            : icon === 'faGreaterThan'
            ? faGreaterThan
            : icon === 'faCoins'
            ? faCoins
            : icon === 'faAngleRight'
            ? faAngleRight
            : icon === 'faHistory'
            ? faHistory
            : icon === 'faPowerOff'
            ? faPowerOff
            : icon === 'faUserLock'
            ? faUserLock
            : icon === 'faPlus'
            ? faPlus
            : icon === 'faTable'
            ? faTable
            : icon === 'faUserAlt'
            ? faUserAlt
            : icon === 'faSyncAlt'
            ? faSyncAlt
            : icon === 'faScroll'
            ? faScroll
            : icon === 'faCommentAltDots'
            ? faCommentAltDots
            : icon === 'faSpellCheck'
            ? faSpellCheck
            : icon === 'faMobile'
            ? faMobile
            : icon === 'faFileSearch'
            ? faFileSearch
            : icon === 'faCopy'
                ? faCopy
            : null
        }
        color={color}
        {...rest}
      />
    </>
  );
};

export default Icon;
